<!-- eslint-disable -->
<template>
  <div class="volume-bars">
    <div 
      v-for="(bar, index) in bars" 
      :key="index"
      class="volume-bar"
      :style="{
        height: `${bar.height}px`,
        transform: `scaleY(${bar.scale})`,
        opacity: bar.opacity
      }"
    />
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted } from 'vue';

const props = defineProps({
  volume: {
    type: Number,
    default: 0,
    validator: value => value >= 0 && value <= 100
  },
  barCount: {
    type: Number,
    default: 5
  }
});

const bars = ref([]);
const lastUpdate = ref(0);

// 高度范围常量
const MIN_HEIGHT = 30;
const MAX_HEIGHT = 60;
const HEIGHT_RANGE = MAX_HEIGHT - MIN_HEIGHT;

// 初始化柱体
const initBars = () => {
  bars.value = Array.from({ length: props.barCount }, () => ({
    height: MIN_HEIGHT,
    targetHeight: MIN_HEIGHT,
    phase: Math.random() * Math.PI * 2,
    scale: 1,
    lastVolume: 0,
    velocity: 0,
    opacity: 0.8
  }));
};

// 更新循环
const updateBars = () => {
  const now = performance.now();
  const deltaTime = Math.min(now - lastUpdate.value, 50) / 1000;
  lastUpdate.value = now;
  
  const volumeFactor = props.volume / 100;
  const volumeChange = volumeFactor - bars.value[0].lastVolume;
  
  bars.value.forEach((bar) => {
    // 1. 高频波动 (更敏感)
    const highFreqWave = Math.sin(now / 70 + bar.phase) * 0.6;
    
    // 2. 低频波动
    const lowFreqWave = Math.sin(now / 400 + bar.phase * 1.3) * 0.4;
    
    // 3. 瞬时变化增强
    const responseBoost = Math.min(Math.abs(volumeChange * 100), 2.5);
    
    // 计算目标高度 (限制在MIN-MAX范围内)
    bar.targetHeight = MIN_HEIGHT + 
      (HEIGHT_RANGE * volumeFactor) + 
      (HEIGHT_RANGE * 0.5 * highFreqWave) + 
      (HEIGHT_RANGE * 0.2 * lowFreqWave) + 
      (HEIGHT_RANGE * 0.3 * responseBoost);
    
    bar.targetHeight = Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, bar.targetHeight));
    bar.lastVolume = volumeFactor;
    
    // 物理模拟 (高灵敏度)
    const stiffness = 0.8; // 更高刚度
    const damping = 0.08; // 更低阻尼
    const displacement = bar.targetHeight - bar.height;
    
    bar.velocity += displacement * stiffness * deltaTime;
    bar.velocity *= (1 - damping);
    bar.height += bar.velocity * 100 * deltaTime;
    
    // 确保最终高度在范围内
    bar.height = Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, bar.height));
    
    // 动态效果
    bar.scale = 0.7 + 0.4 * ((bar.height - MIN_HEIGHT) / HEIGHT_RANGE + highFreqWave * 0.3);
    bar.opacity = 0.7 + 0.3 * ((bar.height - MIN_HEIGHT) / HEIGHT_RANGE);
  });
  
  requestAnimationFrame(updateBars);
};

onMounted(() => {
  initBars();
  requestAnimationFrame(updateBars);
});
</script>

<style scoped>
.volume-bars {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 60px;
  gap: 6px;
  padding: 4px 0;
}

.volume-bar {
  width: 8px;
  border-radius:40px;
  min-height: v-bind('MIN_HEIGHT + "px"');
  background-color: #59B2EA;
  transition: 
    height 0.04s linear,
    transform 0.04s linear,
    opacity 0.08s linear;
  transform-origin: bottom;
  will-change: transform, height, opacity;
}

/* 交替柱子不同的波动方向 */
.volume-bar:nth-child(odd) {
  transform-origin: bottom left;
}
.volume-bar:nth-child(even) {
  transform-origin: bottom right;
}
</style>